module.exports = __webpack_public_path__ + "prod/1.42.2/img/haoweilai-icon.d1f8b479.png";